import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { EmployerService } from 'src/app/employer/employer.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidate-details.component.html',
  styleUrls: ['./candidate-details.component.css']
})
export class CandidateDetailsComponent implements OnInit {


  @Input() resultData = [];
  selectedProfileData;
  @Input() jobId;
  @Input() detailType;
  selectedJobData;
  loading = true;
  total_experience: string[] = [];
  endDateCheck: boolean = false;

  constructor(private employerService: EmployerService, private message: NzMessageService) { }

  ngOnInit() {
    this.loading = true;
    console.log(this.detailType,this.jobId)
    if (this.jobId) {
      if (this.jobId) {
        this.employerService.getJobApplicantsDetails({job_id:this.jobId,status:this.detailType}).subscribe(
          (a:any) => {
            this.resultData = a
            this.loading = false;
          }
        )
      }
      else {
        this.loading = false;
      }
    }
    else {
      this.loading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.resultData) {
      this.loading = false;
      this.viewProfile(this.resultData[0])
    }
  }

  updateJob(type, candidateId) {
    console.log(type, candidateId)
    switch (type) {
      case 'save': {
        this.employerService.createJobApplicantDetails({ job_id: this.jobId, status: 'saved', candidate_id: candidateId }).subscribe(
          (a) => {
            this.message.create('success', `Candidate Saved`);
          }
        )
        break;
      }
      case 'submit': {
        this.employerService.createJobApplicantDetails({ job_id: this.jobId, status: 'submitted', candidate_id: candidateId }).subscribe(
          (a) => {
            this.message.create('success', `Candidate Submitted`);
          }
        )
        break;
      }
      default:
        break;
    }
  }

  viewProfile(data) {
    this.selectedProfileData = data;
    var first_date: Date;
    var second_date: Date;
    var size = this.selectedProfileData.resume.work_experience.length;
    var day = 1000 * 60 * 60 * 24;
    var month: number;
    var year: number;
    var diff: any;
    for (var i = 0; i < size; i++) {
      //calculate only if end date exists
      first_date = new Date(this.selectedProfileData.resume.work_experience[i].start_date);
      if (this.selectedProfileData.resume.work_experience[i].end_date) {
        this.endDateCheck = true;
        second_date = new Date(this.selectedProfileData.resume.work_experience[i].end_date);
      }else{
        second_date = new Date();
        this.endDateCheck = false;
      }
      diff = Math.floor(second_date.getTime() - first_date.getTime());
      month = Math.floor((diff / day) / 31);
      while(month > 12){
        month = month - 12;
      }
      year = Math.floor(((diff / day) / 31 / 12));
      this.total_experience[i] = "" + year + " yr" + " " + month + " mos";

    }
  }

}
